export class BuyerSubscriptionAddModel {
    public subscriptionPlanId: number;
    public paymentIntentId: string;
}
